/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetShiftCoversRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {GetShiftCoversResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const getShiftCovers = (request: GetShiftCoversRequest, options?: CashRequestOptions) => post<GetShiftCoversRequest, GetShiftCoversResponse>("/2.0/cash/get-shift-covers", request, {...options, rejectOnError: true })